import { css } from 'styled-components';
import token from 'styled-token';

/** @class PhotoCarouselSwipeableContainerMixin */
/** @method */
export var PhotoCarouselSwipeableContainerMixin = function PhotoCarouselSwipeableContainerMixin(props) {
  var shouldAnimateTranslations = props.shouldAnimateTranslations;
  return token({
    animationDuration: 'PhotoCarousel.animations.defaultDuration',
    animationFunction: 'PhotoCarousel.animations.defaultTimingFunction'
  }, function (_ref) {
    var animationDuration = _ref.animationDuration,
      animationFunction = _ref.animationFunction;
    return css(["display:flex;flex:1;position:relative;z-index:0;height:100%;touch-action:pan-y;transition:transform ", "s ", ";@media (prefers-reduced-motion:reduce){&{transition:none;}}@media (hover:none){transform:translate3d(0,0,0);}"], shouldAnimateTranslations ? animationDuration : '0', animationFunction);
  });
};